import React , { useState} from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const SignUp = () => {
  const navigate = useNavigate();

  const[signUpEmail, setSignUpEmail] = useState("")
  const[signUpUser, setSignUpUser] = useState("")
  const[signUppassword, setSignUpPassword] = useState("")
  const[signUpErrorDisplay, setSignUpErrorDisplay] = useState(false)

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  const onClickNavigate = (page: string) => {
    navigate(`${page}`);
  };

  const CloseError = () => {
    setSignUpErrorDisplay(false);
  };

  const onClick = () => {
    let hasError = true;

    if (signUpEmail === "") {
      setSignUpErrorDisplay(true);
      hasError = false;
    } else if (!emailRegex.test(signUpEmail)) {
      setSignUpErrorDisplay(true);
      hasError = false;
    } else {
      setSignUpErrorDisplay(false);
    }
    if(signUpUser === ""){
        setSignUpErrorDisplay(true)
    }else {
        setSignUpErrorDisplay(false)
    }
    if (signUppassword === "") {
      setSignUpErrorDisplay(true);
      hasError = false;
    } else {
      setSignUpErrorDisplay(false);
    }
    if (hasError === true) {
      onClickNavigate('/signin')
    }
  };

  return (
    <div className="signUpMainDiv">
      <div className="signUpDiv">
        <div>
          <h2 className="signUpText">Sign Up</h2>
          <div>
            <div className="mb-3 signUpInputField">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputSignUpLabel"
              >
                EMAIL
              </label>
              <input
                className="form-control input-style-signUp inputBorderNone"
                placeholder="Email"
                type="email"
                value={signUpEmail}
                onChange={(e) => setSignUpEmail(e.target.value)}
              />
            </div>
            <div className="mb-3 signUpInputField">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputSignUpLabel"
              >
                USER NAME
              </label>
              <input
                className="form-control input-style-signUp inputBorderNone"
                placeholder="Email"
                type="email"
                value={signUpUser}
                onChange={(e) => setSignUpUser(e.target.value)}
              />
            </div>
            <div className="mb-3 signUpInputField">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputSignUpLabel"
              >
                PASSWORD
              </label>
              <input
                className="form-control input-style-signUp inputBorderNone"
                placeholder="Password"
                type="password"
                value={signUppassword}
                onChange={(e) => setSignUpPassword(e.target.value)}
              />
            </div>

            <div className="submitBtnSignUp">
              <button
                type="submit"
                className="btn btn-primary submitBtnSignUpDiv "
                onClick={onClick}
              >
                Sign Up
              </button>
            </div>
            <div>
            {signUpErrorDisplay === true && (
              <div className="forgotPassSignUpDiv">
                <div className="error-style-SignUp">
                  Invalid email and password
                </div>
                <div className="error-style-SignUp-btn" onClick={CloseError}>
                  <CloseIcon style={{ fontSize: "0.8rem" }} />
                </div>
              </div>
            )}
              <div className="loginSpan">
                if you already have an account?
                <span
                  className="loginDivSignUp"
                  onClick={() => onClickNavigate("/signin")}
                >
                  Sign in
                </span>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
